<div class="contains-button">
  <!-- Hiển thị tiêu đề mở rộng -->
  <div class="editor-header" *ngIf="isViewAll">
    <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
    <span (click)="isViewAll = !isViewAll">{{ currentViewAll.title | translate}} </span>
  </div>

  <ng-container *ngIf="!isViewAll">
    <app-position-out-config [elementChoosing]="objectChoosing" [device]="device"
      [id_parent_choose]="objectChoosing.id_block? objectChoosing.id_block: objectChoosing.id_object">
    </app-position-out-config>

    <app-width-height-config  [device]="device" [elementChoosing]="objectChoosing" [width]="width" [height]="height"
      (changeWidthHeight)="changeWidthHeight($event)">
    </app-width-height-config>
    <ul nz-menu nzMode="inline" [nzInlineCollapsed]="isCollapsed">
      <!-- nút cấu hình cho nút đã chọn hoặc nút chưa chọn(active/inactive) -->
      <div class="row " style="line-height: 1.2;">
        <span class="col-7">
          {{'cau_hinh_nut' | translate}}
          {{ (staticdata.is_favorited ? "da_chon" : "chua_chon") | translate }}
        </span>
        <nz-switch
          class="col-5"
          [(ngModel)]="staticdata.is_favorited"
          (ngModelChange)="changeFavorite()"
        >
        </nz-switch>
      </div>
      <!-- Cấu hình format font name của button -->
      <li nz-submenu nzTitle="{{'dinh_dang_ten_nut' | translate}}" [(nzOpen)]="openMap.menu1"
        (nzOpenChange)="openHandler('menu1')">
        <div class="container-font">
          <div class="config-text" style="width: 100%">
            <!-- Nhập nội dung của nút -->
            <mat-form-field style="width: 100%">
              <mat-label> {{'noi_dung' | translate}}</mat-label>
              <textarea matInput
                [ngModel]="staticdata['content_' + functionService.selectedLanguageCode] | vhLanguage : 'content' : objectChoosing.component"
                (ngModelChange)="staticdata['content_' + functionService.selectedLanguageCode] = $event"
                (blur)="updateStaticData();"></textarea>
            </mat-form-field>
            <!-- Nếu nội dung không có thì phải có nhãn -->
            <mat-form-field style="width: 100%" class="aria-label-input" [matTooltip]="'*_giai_thich_aria_label' | translate"
            *ngIf="!staticdata['content_' + functionService.selectedLanguageCode]?.trim()">
              <mat-label>{{'nhan_cua_nut' | translate}}<span style="color: red">*</span></mat-label>
              <textarea matInput
                [ngModel]="staticdata.accessibility?.['aria_label_' + functionService.selectedLanguageCode]"
                (ngModelChange)="staticdata.accessibility['aria_label_' + functionService.selectedLanguageCode] = $event"
                (blur)="updateStaticData();"></textarea>
            </mat-form-field>
          </div>
          <app-text-format-config 
            [objectChoosing]="objectChoosing"
            [device]="device"  
            [class]="class" 
            [config]="config"
            [staticdata]="staticdata"
            [textContentClass]="class[staticdata.is_favorited ? '+button-favorite__content': '-button-favorite__content']"
            [textWrapperClass]="class[staticdata.is_favorited ? '+button-favorite': '-button-favorite']"
            (changeTextAlignConfig)="changeWidthHeight({width: width})">
          </app-text-format-config>
          <!-- Khoảng cách chữ -->
          <app-letter-spacing-config
            [objectChoosing]="objectChoosing"
            [device]="device"
            [class]="class"
            [classLetterSpacing]="class[staticdata.is_favorited ? '+button-favorite__content': '-button-favorite__content']"
            (updateClass)="updateClass()">
          </app-letter-spacing-config>
          <!-- Khoảng cách dòng -->
          <app-line-height-config
              [objectChoosing]="objectChoosing"
              [device]="device"
              [class]="class"
              [classLineHeight]="class[staticdata.is_favorited ? '+button-favorite__content' : '-button-favorite__content']"
              (updateClass)="updateClass()">
          </app-line-height-config>
          <label class="px-1">{{'gian_cach' | translate}}</label>
          <div class="padding">
            <div class="d-flex items justify-content-between">
              <img src="./assets/root/images/system/icons/padding-right-left.svg" alt="padding" width="30px" />
              <nz-input-number [nzMin]="0" [nzMax]="200" style="max-width: 50%" [nzStep]="1"
                [(ngModel)]="config['padding']"
                (nzBlur)="updateConfig(); changeWidthHeight({width: width})">
              </nz-input-number>
            </div>
             
          </div>
        </div>
      </li>
      <!-- Cấu hình màu nền của button -->
      <li nz-submenu nzTitle="{{'mau_sac' | translate}}" [(nzOpen)]="openMap.menu4"
        (nzOpenChange)="openHandler('menu4')">
        <div class="container-color">
          <button id="btn-color" *ngFor="let background of backgroundColor; let i = index"
            [ngStyle]="{ 'background-color': background.bgColor }" (click)="chooseBg(background, $event)" nz-tooltip
            [disabled]="config['background-color'].gradient_check"></button>
        </div>
        <div class="color-pick">
          <span class="title w-50">{{'mau_nen' | translate}}</span>
          <input class="input-color w-50" type="button" [cpOKButton]="true" [(colorPicker)]="class[staticdata.is_favorited ? '+button-favorite' :'-button-favorite']['background-color']"
            [style.background]="class[staticdata.is_favorited ? '+button-favorite' :'-button-favorite']['background-color']" (colorPickerClose)="updateObject()"
            [cpWidth]="'230px'" />
        </div>
        <div class="mr-2 mb-4 mt-4 view-more" style="
            display: flex;
            align-items: center;
            justify-content: flex-end;
            gap: 7px;
          ">
          <p class="discover_text" (click)="openViewAll(styles_field[3])"
            style="cursor: pointer; text-align: left; margin: 0">
            {{'mo_rong' | translate}} &#8594;
          </p>
        </div>
        <!-- Mở popup so sánh màu tương phản -->
        <button *ngIf="staticdata['content_' + functionService.selectedLanguageCode]"
        nz-row (click)="openColorContrast()" nz-tooltip
        [nzTooltipTitle]="'dung_de_toi_uu_chi_so_accessibility_kha_nang_tiep_can_tren_pagespeed' | translate"
        style="color: #fff; background-color: #00a859; width: 100%; padding: 8px; border-radius: 8px;">
          {{ 'so_sanh_do_tuong_phan_giua_mau_chu_icon_va_mau_nen' | translate }}
        </button>
      </li>
      <!-- Cấu hình biểu tượng -->
      <li nz-submenu nzTitle="{{'bieu_tuong' | translate}}" [(nzOpen)]="openMap.menu7"
        (nzOpenChange)="openHandler('menu7')">
        <app-symbol-config 
          [device]="device" 
          [class]="class" 
          [config]="config" 
          [symbolClass]="class[staticdata.is_favorited ? '+button-favorite' :'-button-favorite']"
          [fontSizeIconClass]="class[staticdata.is_favorited ? '+button-favorite__content--icon-wrapper': '-button-favorite__content--icon-wrapper']" 
          [symbolConfig]="config['flex-direction']"
          [objectChoosing]="objectChoosing">
        </app-symbol-config>
      </li>
      <!-- Cấu hình đổ bóng -->
      <li nz-submenu nzTitle="{{'do_bong' | translate}}" [(nzOpen)]="openMap.menu5"
        (nzOpenChange)="openHandler('menu5')">
        <app-shadow-config [device]="device" [config]="config" [class]="class" [shadowClass]="class[staticdata.is_favorited ? '+button-favorite' :'-button-favorite']"
          [shadowConfig]="config['box-shadow']" [objectChoosing]="objectChoosing">
        </app-shadow-config>
      </li>
      <!-- Cấu hình hình dạng viền -->
      <li nz-submenu nzTitle="{{'kieu_vien' | translate}}" [(nzOpen)]="openMap.menu6"
        (nzOpenChange)="openHandler('menu6')">
        <app-borders-config [device]="device" [class]="class" [borderClass]="class[staticdata.is_favorited ? '+button-favorite' :'-button-favorite']" [elementChoosing]="objectChoosing"
          [id_object]="objectChoosing._id">
        </app-borders-config>

        <!-- Nút mở rộng -->
        <div class="item-border my-3" style="float: right">
          <p class="m-0 title-border my-2" (click)="openViewAll(styles_field[1])">
            {{'mo_rong' | translate}} &#8594;
          </p>
        </div>
      </li>
      <!-- Cấu hình xoay-->
      <li nz-submenu nzTitle="{{'cau_hinh_xoay' | translate}}" [(nzOpen)]="openMap.menu10"
        (nzOpenChange)="openHandler('menu10')">
        <app-rotate-config [classRotate]="class[staticdata.is_favorited ? '+button-favorite' : '-button-favorite']" [config]="config" [device]="device"  [objectChoosing]="objectChoosing" ></app-rotate-config>
      </li>
      <!-- Cấu hình hiệu ứng -->
      <li nz-submenu nzTitle="{{'hieu_ung' | translate}}" [(nzOpen)]="openMap.menu8"
        (nzOpenChange)="openHandler('menu8')">
        <app-choose-animations-config [type]="type" [elementChoosing]="objectChoosing" (openAnimationDetail)="openAnimationDetail($event)"
          [id_object]="objectChoosing._id" [device]="device" [class]="class" [config]="config" [staticdata]="staticdata"
          [cursorClass]="class[staticdata.is_favorited ? '+button-favorite' :'-button-favorite']" [effect_hover]="effect_hover" [customize]="customize" [type]="'object'" [effectFileUsing]="'button'">
        </app-choose-animations-config>
      </li>
      <!-- Cấu hình thêm liên kết -->
      <li *ngIf="!objectChoosing.dynamic_data" nz-submenu nzTitle="{{'lien_ket' | translate}}"
        [(nzOpen)]="openMap.menu9" (nzOpenChange)="openHandler('menu9')">
        <app-link-page-config [staticdata]="staticdata" [id_object]="objectChoosing._id" [blocks_of_page]="blocks_of_page"></app-link-page-config>
      </li>
      <!-- Cấu hình thông số cơ bản của button-->
      <li nz-submenu nzTitle="{{'hien_thi' | translate}}" [(nzOpen)]="openMap.menu3"
        (nzOpenChange)="openHandler('menu3')">
        <div class="button-size">
          <!-- Lựa chọn hiển thị cho các thiết bị -->
          <app-hide-show-config [device]="device" [elementChoosing]="objectChoosing">
          </app-hide-show-config>
        </div>
      </li>
    </ul>
  </ng-container>

  <!-- Xem chi tiết cấu hình object -->
  <div class="view-more" *ngIf="isViewAll">
    <!-- Cấu hình chi tiết viền -->
    <div class="view_more-border" *ngIf="currentViewAll.index == 2">
      <app-borders-radius-config [device]="device" [class]="class" [borderRadiusClass]="class[staticdata.is_favorited ? '+button-favorite' :'-button-favorite']"
        [id_object]="objectChoosing._id">
      </app-borders-radius-config>
    </div>

    <!-- Cấu hình chi tiết hiệu ứng -->
    <div class="editor_effect-hover" *ngIf="currentViewAll.index == 3">
       <app-animations-config [type]="type" [elementChoosing]="objectChoosing" [staticdata]="staticdata" [id_object]="objectChoosing._id" [customize]="customize"
        [device]="device" ></app-animations-config>
    </div>
    <!-- Cấu hình chi tiết màu gradient  -->
    <div class="container-gradient" *ngIf="currentViewAll.index == 4">
      <div class="title-head">
        <p class="text-fill">{{'phoi_mau' | translate}}</p>
        <label nz-checkbox [(ngModel)]="config['background-color'].gradient_check"
          (ngModelChange)="updateBackgroundRgb()"></label>
      </div>
      <div class="list-gradient">
        <button class="btn-gradient" *ngFor="
            let bgGradient of config['background-color']['gradient_arr'];
            let i = index
          " (click)="deleteGradient(i)" [ngStyle]="{ 'background-color': bgGradient }"
          [disabled]="!config['background-color'].gradient_check">
          <i class="delete-icon bi bi-x-circle"></i>
        </button>
      </div>
      <p class="title-head">{{'them_mau' | translate}}</p>
      <div class="container_add-gradient">
        <input class="input-color" [cpOKButton]="true" [(colorPicker)]="class[staticdata.is_favorited ? '+button-favorite' :'-button-favorite']['background-color']" type="button"
          [disabled]="!config['background-color'].gradient_check"
          [style.background]="class[staticdata.is_favorited ? '+button-favorite' :'-button-favorite']['background-color']" (colorPickerClose)="addGradient($event)" />
      </div>
      <p class="title-head">{{'huong_phoi_mau' | translate}}</p>
      <button class="gradient-direction" *ngFor="let type of typeGradient" nz-tooltip nzTooltipTitle="{{type.name | translate}}"
        (click)="chooseOption(type, $event)" [disabled]="!config['background-color'].gradient_check" [style.background]="
          'linear-gradient(' + type.deg + ', #2764EB, #EFE810)'
        "></button>
    </div>
  </div>
</div>
